<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-md-offset-1">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard ref="wizard" error-color="#EB5E28" color="#1e94fd" title="Intereses" subtitle="" @on-complete="siguente" @on-change="cancelAll">
            <tab-content title="Participación en empresas, sociedades, asociaciones (Hasta los últimos 2 años)" icon="ti-briefcase">
              <empresas-soc ref="EmpresasSoc"></empresas-soc>
            </tab-content>
            <tab-content title="¿Participa en la toma de decisiones de alguna de estas instituciones? (Hasta los últimos 2 años)" icon="ti-comment-alt">
              <decisiones ref="Decisiones"></decisiones>
            </tab-content>
            <tab-content title="Apoyos o beneficios públicos (Hasta los últimos 2 años)" icon="ti-money">
              <apoyos ref="Apoyos"></apoyos>
            </tab-content>
            <tab-content title="Representación (Hasta los últimos 2 años)" icon="ti-user">
              <representacion ref="Representacion"></representacion>
            </tab-content>
            <tab-content title="Clientes Principales (Hasta los 2 últimos años)" icon="ti-agenda">
              <clientes-principales ref="ClientesPrincipales"></clientes-principales>
            </tab-content>
            <tab-content title="Beneficios Privados (Hasta los últimos 2 años)" icon="ti-world">
              <beneficios-privados ref="BeneficiosPrivados"></beneficios-privados>
            </tab-content>
            <tab-content title="Fideicomisos (Hasta los últimos 2 años)" icon="ti-bookmark-alt">
              <fideicomisos ref="Fideicomisos"></fideicomisos>
            </tab-content>
            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back"> Atrás </button>
            <button slot="next" class="btn btn-info btn-fill btn-wd btn-next"> Siguiente </button>
            <button slot="finish" class="btn btn-info btn-fill btn-wd btn-next"> Siguiente</button><!-- @click="siguente()" -->
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    FormWizard,
    TabContent
  } from "vue-form-wizard";
  import "vue-form-wizard/dist/vue-form-wizard.min.css";
  import EmpresasSoc from "./Formularios/Intereses/EmpresasSoc.vue";
  import Decisiones from "./Formularios/Intereses/Decisiones.vue";
  import InteresesEmp from "./Formularios/Intereses/InteresesEmpresas.vue";
  import Membresias from "./Formularios/Intereses/Membresias.vue";
  import Apoyos from "./Formularios/Intereses/Apoyos.vue";
  import Representacion from "./Formularios/Intereses/Representacion.vue";
  import Fideicomisos from "./Formularios/Intereses/Fideicomisos.vue";
  import ClientesPrincipales from "./Formularios/Intereses/ClientesPrincipales.vue";
  /* import RepresentacionPasiva from "./Formularios/Intereses/RepresentacionPasiva.vue";
  import SociosComerciales from "./Formularios/Intereses/SociosComerciales.vue";
  import OtrasPartes from "./Formularios/Intereses/OtrasPartes.vue"; */
  import BeneficiosPrivados from "./Formularios/Intereses/BeneficiosPrivados.vue";
  import swal from "sweetalert2";
  export default {
    data() {
      return {};
    },
    components: {
      FormWizard,
      TabContent,
      EmpresasSoc,
      Decisiones,
      InteresesEmp,
      Membresias,
      Apoyos,
      Representacion,
      Fideicomisos,
      ClientesPrincipales,
      BeneficiosPrivados
      /* RepresentacionPasiva,
      SociosComerciales,
      OtrasPartes,*/
    },
    watch: {
      $route: "checkPermissions"
    },
    methods: {
      cancelAll() {
        var tab = this.$refs.wizard.tabs[this.$refs.wizard.activeTabIndex].$children;
        tab[0].cancelEdit();

      },
      checkPermissions() {
        //&& this.getKey("status_dec") == 1 && this.getKey("grupo") != 3
        if (!(this.getKey("role") == 0 )) {
          localStorage.clear();
          this.$router.push("/login");
          this.$router.go();
        }
      },
      siguente() {
        this.checkPermissions()
        this.$router.push("ingresos");
      }
    },
    created() {
      this.checkPermissions();
    },
    mounted() {
      this.$refs.wizard.activateAll();
    }
  };

</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9a9a9a !important;
    color: white;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Intereses.vue